import React, {useEffect} from "react";
import NotPermissionComponent from "../NotPermissionComponent";
import {ItemInfo, ItemNumber} from "../../components/ViewData";
import * as IconMaterial from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import {PropertiesInterface} from "../../../services/interface/query/properties-interface";
import {Person} from "../../../services/interface/query/person";
import {useFindProperties} from "../../../services/apis/apiProperties";
import NoRecords from "../../components/NoRecords";

interface Props {
    person?: Person;
}

export default function PropertiesList({person}: Props): JSX.Element {
    const {t} = useTranslation("global") as { t: (key: string) => string };

    const {
        mutate: findProperties,
        data: successProperties,
        isPending: loadingProperties,
        error: errorPropertiesProperties,
    } = useFindProperties();

    const [list, setList] = React.useState<PropertiesInterface[] | undefined>()
    const styleIcon = 'max-w-[20px] max-h-[20px]'

    useEffect(() => {
        if (person && person.identification) {
            setList(undefined)
            findProperties({identifier: person.identification, msj: t('properties2')})
        }
    }, [person]);

    useEffect(() => {
        if (successProperties) {
            setList(successProperties)
        }
    }, [successProperties]);

    return (
        <>
            <h3 className={'capitalize'}>{t('properties2')}</h3>
            <NotPermissionComponent
                title={'/property_assets/realEstateProperties'}
                loading={loadingProperties}
                error={errorPropertiesProperties}
                component={<>
                    {(!loadingProperties && list && list.length > 0) ?
                        <>
                            {list.map((item, index) => (
                                <div key={index}>
                                    <h5>{`${t('register')} #${index + 1}`}</h5>
                                    <div
                                        className={'mt-1 custom-card py-3 px-3 grid lg:grid-cols-2 xl:grid-cols-3 gap-2 items-center'}>
                                        <ItemInfo
                                            label={t('property')}
                                            text={item.typeAsset}
                                            icon={<IconMaterial.HomeTwoTone className={styleIcon}/>}
                                        />
                                        <ItemInfo
                                            label={t('qualification-property')}
                                            text={item.description}
                                            icon={<IconMaterial.BookTwoTone className={styleIcon}/>}
                                        />
                                        <ItemNumber
                                            className={'min-h-[30px]'}
                                            label={t('total-appraisal')}
                                            value={`$${item.totalValue}`}
                                        />
                                    </div>
                                </div>
                            ))}
                        </> : <NoRecords/>
                    }
                </>}
            />
        </>
    )
}
